exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rows[data-v-066c76de]{\r\n  color: black;\n}\n#view-button[data-v-066c76de] {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  box-shadow: none;\r\n  outline: none;\n}\n#view-button i[data-v-066c76de] {\r\n  color: #1c869a;\r\n  font-size: 22px;\n}\n#view-button i[data-v-066c76de]:hover {\r\n  color: #31bdda;\r\n  transition: 0.5s;\n}\r\n", ""]);

// exports
